function dynamicSpacingOfString(str, specialCharacters) {
    return str.split(specialCharacters);
}

export default dynamicSpacingOfString;